/**
 * Labstep
 *
 * @module core/Form/ReactForm/ProseMirrorHtml
 */

import { ProseMirrorHtmlOnly } from 'labstep-web/prosemirror/HtmlOnly';
import type React from 'react';
import { Controller } from 'react-hook-form';
import type { IProseMirrorHtmlFieldProps } from './types';

export const ProseMirrorHtml: React.FC<IProseMirrorHtmlFieldProps> = (
  props,
) => (
  <Controller
    name={props.name}
    control={props.control}
    render={({ field }): React.ReactElement => {
      const { value, onChange } = field;

      return (
        <ProseMirrorHtmlOnly
          initialState={typeof value === 'string' ? value : ''}
          onChange={onChange as any}
        />
      );
    }}
  />
);
